import React, { useContext, useState } from 'react';
import ModalContext from '../../../context/ModalContext.js';
import AuthContext from '../../../context/AuthContext.js';
import { Button, CircularProgress } from '@mui/material';

const MakeSuperAdminModal = ({ modalDetails }) => {
  const modalCtx = useContext(ModalContext);
  const authCtx = useContext(AuthContext);
  const [updating, setUpdating] = useState(false);

  const closeHandle = () => {
    modalCtx.closeModal();
  };

  const handleMakeSuperAdmin = () => {
    if (!modalDetails?.id) return;
    setUpdating(true);
    fetch(`${process.env.REACT_APP_API_URI}/v3/admin/administrators/${modalDetails.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + authCtx.token
      },
      body: JSON.stringify({ id: modalDetails.id, access: 'superadmin' })
    })
      .then(res => res.json())
      .then(data => {
        setUpdating(false);
        if (data.status === 'success') {
          modalCtx.setPageUpdate({ page: 'Administrators' });
          modalCtx.closeModal();
        } else {
          alert('Failed to update to super admin.');
        }
      })
      .catch(() => {
        setUpdating(false);
        alert('Failed to update to super admin.');
      });
  };

  return (
    <div className="modal-container">
      <div className='modal-header'>
        <h1>Make Super Admin</h1>
      </div>
      <div className="modal-body">
        <span>Are you sure you want to make this user a Super Admin?</span>
      </div>
      <div className="modal-footer">
        <Button className="cancel-btn" onClick={closeHandle} disabled={updating}>CANCEL</Button>
        <Button onClick={handleMakeSuperAdmin} disabled={updating} variant="contained">
          {updating ? <CircularProgress size={16} style={{ color: "#fff" }} /> : ''} MAKE SUPER ADMIN
        </Button>
      </div>
    </div>
  );
};

export default MakeSuperAdminModal; 